export default "__VITE_ASSET__vmPe7WZy__"